import * as React from "react";

interface IProps extends React.HTMLProps<HTMLDivElement> {
  onOutsideClick: () => void;
}

export default class WithOutsideClick extends React.PureComponent<IProps> {
  private node: HTMLDivElement | null = null;

  componentDidMount() {
    document.addEventListener("click", this.onOutsideClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onOutsideClick, true);
  }

  onOutsideClick = (e: MouseEvent) => {
    if (!this.node || !this.node.contains(e.target as any)) {
      const { onOutsideClick } = this.props;
      onOutsideClick();
    }
  };

  setRef = (e: HTMLDivElement) => (this.node = e);

  render() {
    const { children, onOutsideClick, ...props } = this.props;
    return (
      <div {...props} ref={this.setRef}>
        {children}
      </div>
    );
  }
}
